import React from 'react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Flex, Text } from '@chakra-ui/react'

import { formatVideoLength } from 'utils/formatVideoLength'

import { Button } from '../Buttons/Button'
import LeidModal from '../Modal/LeidModal'

import { Player, PlayerWrapper, StyledLoader } from './styles'

type Props = {
  isOpen: boolean
  onClose: () => void
  videoUrl: string
  videoTitle: string
  videoLength: string | null
}

export const VideoModal: React.FC<Props> = ({ isOpen, onClose, videoUrl, videoTitle, videoLength }) => {
  const { t } = useTranslation()

  const [isLoading, setIsLoading] = useState(true)

  const isConsentGiven = () => {
    if (typeof window === 'undefined') {
      return true
    }

    if (!window.CookieInformation) {
      return true
    }

    return (
      window.CookieInformation.getConsentGivenFor('cookie_cat_statistic') &&
      window.CookieInformation.getConsentGivenFor('cookie_cat_marketing')
    )
  }

  const renewConsent = () => {
    if (typeof window === 'undefined') {
      return
    }

    window.CookieConsent?.renew()
  }

  const consentIsGiven = isConsentGiven()

  return (
    <LeidModal header={videoTitle} isOpen={isOpen} onClose={onClose} size={{ base: 'cover', md: 'xl' }}>
      <Flex
        width="54px"
        height="54px"
        backgroundColor="green.a200"
        borderRadius="12px"
        position="absolute"
        right={{ base: 0, md: '-74px' }}
        top={{ base: '-74px', md: 0 }}
        alignItems="center"
        justifyContent="center"
        cursor="pointer"
        onClick={onClose}
      >
        <img src="/icons/close-light.svg" alt="Close" />
      </Flex>

      <Flex align="flex-start" height="100%">
        <Box flexGrow={1}>
          {consentIsGiven ? (
            <PlayerWrapper>
              <>
                {isLoading && <StyledLoader />}
                <Player
                  onReady={() => {
                    setIsLoading(true)
                  }}
                  url={videoUrl}
                  width="100%"
                  height="100%"
                />
              </>
            </PlayerWrapper>
          ) : (
            <Box
              className="consent-placeholder"
              data-category="cookie_cat_marketing"
              width="100%"
              position="relative"
              // paddingTop="56.25%"
              borderRadius="big"
              overflow="hidden"
              backgroundColor="green.a250"
            >
              <Box padding={5} paddingTop="25%" paddingBottom="25%">
                <Text fontSize="md" marginBottom={3} color="white" textAlign="center">
                  {t('noMarketingConsent')}
                </Text>{' '}
                <Button onClick={renewConsent}>{t('acceptConsent')}</Button>
              </Box>
            </Box>
          )}

          {videoLength && (
            <Text color="green.a200" fontSize="sm" fontWeight="700">
              {formatVideoLength(videoLength)}
            </Text>
          )}
        </Box>
      </Flex>
    </LeidModal>
  )
}
